import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';

// export default router
const requireAuth = () => (from, to, next) => {
  if (store.getters.isAuthenticated) return next();
  next('/?returnPath=list');
};
const requireAuthWithLevel = () => (from, to, next) => {
  if (store.getters.isAuthenticated) {
    let token = store.getters.getAccessToken;
    let base64Url = token.split('.')[1];
    let base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    let jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );
    const user = JSON.parse(jsonPayload);
    const level = user.level;
    if (level === 1 || level === 2) {
      return next();
    } else {
      return next('block');
    }
  }
  next('/?returnPath=list');
};
const requireManagerAuth = () => (from, to, next) => {
  // if (store.getters.isAuthenticated)return next()
  // next('/?returnPath=list');
  if (store.getters.isAuthenticated) {
    let auth = store.getters.getAuth;
    let routers = [];

    // menus.unshift(allMenus[0]);

    routers.push('/', '/dashboard');
    for (let i of auth) {
      if (i.to != null) {
        routers.push(i.to);
      }
      if (i.hasOwnProperty('items')) {
        for (let j of i['items']) {
          routers.push(j.to);
        }
      }
    }
    // allMenus[parentIdx].items = newChildren;
    // menus.push(allMenus[parentIdx]);
    if (routers.filter(router => router == to.fullPath).length > 0) {
      return next();
    } else {
      return next('block');
    }
  }
  next('/?returnPath=list');
};

Vue.prototype.$router = VueRouter;
Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () =>
        import(
          /* webpackChunkName: "views-sign-in" */
          '@/layouts/authentication/Index'
        ),
      children: [
        {
          path: '/',
          name: 'SignIn',
          component: () =>
            import(
              /* webpackChunkName: "views-sign-in" */
              '@/views/authentication/SignIn'
            ),
        },
        {
          path: '/signup-agreement',
          name: 'SignUpAgreement',
          component: () =>
            import(
              /* webpackChunkName: "views-sign-up" */
              '@/views/SignUpAgreement'
            ),
        },
        {
          path: '/signup-form',
          name: 'SignUpForm',
          component: () =>
            import(
              /* webpackChunkName: "views-sign-up" */
              '@/views/SignUpForm'
            ),
        },
      ],
    },
    {
      path: '/dashboard',
      beforeEnter: requireAuth(),
      component: () =>
        import(
          /* webpackChunkName: "layouts-default-index" */
          '@/layouts/default/Index'
        ),
      props: true,
      children: [
        {
          path: '/order',
          name: 'Order',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Order'
            ),
          props: route => ({
            // id: route.params.id,
            query: route.query,
          }),
          props: true,
        },
        {
          path: '/order/detail/:id',
          name: 'Order - detail',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/OrderDetail'
            ),
        },
        {
          path: '/order/place-order',
          name: 'Order - registration',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/OrderPlace'
            ),
          props: true,
        },
        {
          path: '/inquiry',
          name: '의뢰서 등록',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-inquiry" */
              '@/views/Inquiry'
            ),
        },
        {
          path: '/analysis',
          name: 'Analysis',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Analysis'
            ),
        },
        {
          path: '/result',
          name: 'Result',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Result'
            ),
        },
        // {
        //     path: '/result/detail',
        //     name: 'ResultDetail',
        //     component: () => import(
        //     /* webpackChunkName: "views-dashboard" */
        //     '@/views/GridTable'
        //     ),
        // },
        {
          path: '/mypage',
          name: 'Profile',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Mypage'
            ),
        },
        {
          path: '/dashboard',
          name: 'Dashboard',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/DashboardPage'
            ),
        },
        {
          path: '/manage',
          name: 'Manage',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Manage'
            ),
        },
        {
          path: '/manage/detail/:id',
          name: 'ManageDetail',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/ManageDetail'
            ),
        },
        {
          path: '/contact',
          name: '1:1 Inquiry',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Contact'
            ),
        },
        {
          path: '/contact/regist',
          name: '1:1 Inquiry - regist',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/components/contact/Regist'
            ),
          props: true,
        },
        {
          path: '/contact/read/:id',
          name: '1:1 Inquiry - detail',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/components/contact/Read'
            ),
          props: true,
        },
        {
          path: '/datasets',
          name: 'Datasets',
          beforeEnter: requireAuthWithLevel(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Datasets'
            ),
        },
        {
          path: '/virus',
          name: 'Virus',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-virus" */
              '@/views/Virus'
            ),
        },
        {
          path: '/analysis/wide',
          name: 'TaxonomyWide',
          beforeEnter: requireAuth(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/TaxonomyWide'
            ),
          props: true,
        },
        {
          path: '/user/list',
          name: 'UserList',
          beforeEnter: requireAuthWithLevel(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/UserListPage'
            ),
        },
        {
          path: '/company/list',
          name: 'CompanyList',
          beforeEnter: requireAuthWithLevel(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/CompanyListPage'
            ),
          props: true,
        },
        {
          path: '/admin',
          name: 'Admin',
          beforeEnter: requireAuthWithLevel(),
          component: () =>
            import(
              /* webpackChunkName: "views-dashboard" */
              '@/views/Admin'
            ),
          props: true,
        },
      ],
    },
    {
      path: '/block',
      name: '차단',
      component: () => import('@/views/Block'),
    },
  ],
});
